import { action, computed, makeObservable, override } from 'mobx';
import { createContext, useContext } from 'react';
import { SubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import { redirectToRoute } from 'routes/redirectToRoute';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import EmployeeFlowDelegate from 'store/flows/subscriber/employeeFlowDelegate';
import IEmploymentDetailsPage from 'store/modules/subscriber/employment-details/iEmploymentDetailsPage';

export default class EmploymentDetailsPageStore extends IEmploymentDetailsPage {
  public readonly flowDelegate: EmployeeFlowDelegate;

  public get isInitialLoading(): boolean {
    return this.flowDelegate.isFlowDataLoading || this.isPageContentLoading;
  }

  protected onCompleteRedirect(): void {
    this.flowDelegate.onCompleteRedirect();
  }

  public returnBack(): void {
    redirectToRoute(SubscriberRouteV2Id.EMPLOYEE_PROFILE, { groupId: this.domainParams.groupId });
  }

  public override setIsInitialDataLoading(status: boolean): void {
    super.setIsInitialDataLoading(status);
    this.flowDelegate.setIsInitialDataLoading(status);
  }

  constructor(domainParams: SubscriberDomainParams) {
    super(domainParams);
    this.flowDelegate = new EmployeeFlowDelegate({ domainParams });

    makeObservable<EmploymentDetailsPageStore, 'onCompleteRedirect' | 'setIsInitialDataLoading'>(this, {
      isInitialLoading: computed,
      onCompleteRedirect: action.bound,
      returnBack: action.bound,
      setIsInitialDataLoading: override,
    });
  }
}

const EmploymentDetailsPageStoreContext = createContext(
  new EmploymentDetailsPageStore({ groupId: '', subscriberId: '', entityId: '' }),
);

export const useEmploymentDetailsPageStore = (): EmploymentDetailsPageStore => {
  return useContext(EmploymentDetailsPageStoreContext);
};

export { EmploymentDetailsPageStoreContext };
